export const INITIAL_FOCUS_SELECTOR = '.ftv-magneto--skip-btn,[name="btn-play"],[name="btn-first-play"]';
